import { render, staticRenderFns } from "./InvitacionesAgrupadasComponent.vue?vue&type=template&id=2c9c63da"
import script from "./InvitacionesAgrupadasComponent.vue?vue&type=script&lang=js"
export * from "./InvitacionesAgrupadasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports